import {ChangeDetectionStrategy, Component, ViewEncapsulation} from '@angular/core';
import {PageMetaService} from '../../common/services/page-meta/page-meta.service';
import {ActiveCampaignsComponent} from "../home-page/sections/active-campaigns/active-campaigns.component";

@Component({
  selector: 'app-campaigns-page',
  template: `
    <app-active-campaigns-section-component/>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ActiveCampaignsComponent
  ],
  standalone: true
})
export class CampaignsPage {
  readonly title: string = `Campaigns at Car for Ukraine Volunteering Initiative`;
  readonly description: string = `At Car for Ukraine we source, upgrade and deliver cars to the frontlines in Ukraine.`;

  constructor(private pageMetaService: PageMetaService) {
    this.pageMetaService.setTitleAndDescription({
      title: this.title,
      description: this.description
    });
  }
}

export default CampaignsPage;
